import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private isBrowser: boolean;
  private isTestEnvironment: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  setTestEnvironment(value: boolean) {
    this.isTestEnvironment = value;
  }

  navigate(url: string) {
    if (this.isBrowser && !this.isTestEnvironment) {
      this.router.navigate([url]);
    }
  }

  reload() {
    if (this.isBrowser && !this.isTestEnvironment) {
      const currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
  }
}